import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    ingresos: [],
  },

  getters: {
    getIngresos: (state) => state.ingresos,
  },

  mutations: {
    SET_INGRESOS(state, ingresos) {
      state.ingresos = ingresos;
    },
  },

  actions: {
    async fetchIngresos({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catingresos')
        .then((response) => {
          commit('SET_INGRESOS', response.data.data);
        });
    },
  },
};
